export enum RutaSesionTipoEnum {
	sesion = 'sesion',
	evaluacion = 'evaluacion',
	proyecto = 'proyecto',
	evaluacionInstrumento = 'evaluacionInstrumento'
}

export enum ActividadTipoEnum {
	grupal = 'grupal',
	individual = 'individual',
	proyectoGrupal = 'proyectoGrupal',
	proyectoIndividual = 'proyectoIndividual',
	evaluacion = 'evaluacion'
}

export enum ActividadViewTipoEnum {
	guia = 'guia',
	instrumentoEvaluacion = 'instrumentoEvaluacion'
}

export enum RubricaTipoEnum {
	autoevaluacion = 'autoevaluacion',
	heteroevaluacion = 'heteroevaluacion',
	coevaluacion = 'coevaluacion'
}
